/**
 * Dependencies
 */

import gql from "graphql-tag";
import moment from 'moment';

import doctorList from '../../../stories/mock/doctorList';

// import doctors from '../../../stories/mock/doctors.json';
// import conditionsOrProcedure from '../../../stories/mock/conditionOrProcedure.json';

class appointmentFinderService {
	constructor($http, apollo) {
		this.$http = $http;
		this.apollo = apollo;
	}

	getCarriers(lang) {
		return new Promise((resolve, reject) => {
			// resolve(carriers);
			this.apollo
				.query({
					query: gql `
					query {
						getAllCarrier(lang:"${lang}") {
							id
							name
							rank
						  }
						}
					`
				})
				.then(result => {
					const {
						getAllCarrier
					} = result.data;
					resolve([...getAllCarrier.map(item => Object.assign({}, item))]);
				}).catch(error => {
					reject(error);
				});
		});

	}

	getPlans(lang) {
		return new Promise((resolve, reject) => {
			// resolve(carriers);
			this.apollo
				.query({
					query: gql `
					query {
						getAllmedicalPlane(lang:"${lang}") {
							id
							name
							rank
							carrier{
							  id
							  name
							  rank      
							}
						  }
						}
					`
				})
				.then(result => {
					const {
						getAllmedicalPlane
					} = result.data;
					let plans = [
						...getAllmedicalPlane.map(item => Object.assign({
							carrierid: item.carrier.id
						}, item))
					];
					resolve(plans);
				}).catch(error => {
					reject(error);
				});
		});
	}

	getAddress(lang) {
		return new Promise((resolve, reject) => {
			this.apollo
				.query({
					query: gql `
					query {
						getAllUniqueAddress(lang:"${lang}") {
							id
							city
							zip
							state
							country
						  }
						}
					`
				})
				.then(result => {
					const {
						getAllUniqueAddress
					} = result.data;
					resolve([...getAllUniqueAddress.map(item => Object.assign({}, item))]);
				}).catch(error => {
					reject(error);
				});
		});
	}

	getDoctorList(lang) {
		return new Promise((resolve, reject) => {
			this.apollo
				.query({
					query: gql `
					query {
						getAllDoctors(lang:"${lang}") {
							id
							firstName
							lastName
							age
							title
							gender
							details
							address {
							  id
							  city
							  zip
							  latitude
							  longitude
							  state
							  streetAddress
							  country
							}
							horary {
							  id
							  date
							}
							image
							rating
						
							procedure {
							  id
							  name
							}
							language {
							  id
							  name
							}
						  }
						}
					`
				})
				.then(result => {
					const {
						getAllDoctors
					} = result.data;
					let doctors = getAllDoctors.map(item => {
						return {
							doctor: {
								name: `${item.firstName} ${item.lastName}, ${item.title}`,
								synthesis: (item.details) ? item.details : '',
								address: this.formatedAddress((item.address && angular.isArray(item.address) && item.address[0]) ? item.address[0] : {}),
								stars: (item.rating) ? item.rating : '',
								profession: '',
								image: (item.image) ? item.image : '',
								gender: item.gender,
							},
							isSponsored: false,
							horary: this.createHorary(item.horary),
							carriers: (item.carriers) ? [...item.carriers] : [],
							procedures: (item.procedure) ? [...item.procedure.map(item => Object.assign({}, item))] : [],
							languages: (item.language) ? [...item.language.map(item => Object.assign({}, item))] : [],
							address: (item.address) ? [...item.address.map(item => Object.assign({}, item))] : [],
						}
					})
					resolve(doctors);
				}).catch(error => {
					reject(error);
				});

		});
	}

	formatedAddress(address) {
		return (address) ? `
		${(address.country) ? address.country : ''},
		${(address.state) ? address.state : ''},
		${(address.city) ? address.city : ''},
		${(address.streetAddress) ? address.streetAddress : ''},
		${(address.zip) ? address.zip : ''}
		` : '';
	}

	createHorary(itemhorary) {
		let horary = {};
		itemhorary.map((item) => {
			if (item.date) horary[moment(item.date[0]).format('YYYY-MM-DD')] = item.date;
		});
		return horary;
	}

	getDoctorFilter(lang) {
		const defaultdoctorListFilter = {
			problem: [],
			languages: [],
			selectedHealthIssue: 'any',
			selectedGender: 'any',
			selectedDay: 'any',
			selectedLanguage: 'any',
			children: false,
			before: false,
			after: false,
			address: '',
			sortFields: [{
				id: 'default',
				name: 'default order'
			}, {
				id: 'distance',
				name: 'distance'
			}, {
				id: 'wait',
				name: 'wait time rating'
			}],
			sortBy: 'default',

		};

		return new Promise((resolve, reject) => {
			this.apollo
				.query({
					query: gql `
					query {
						getAllProcedures(lang:"${lang}") {
							id
							name
						  }
						  getAllLanguages {
							id
							name
						  }
						}
					`
				})
				.then(result => {
					let {
						getAllProcedures,
						getAllLanguages
					} = result.data;
					let doctorListFilter = {
						...defaultdoctorListFilter,
						problem: [{
							id: 'any',
							name: "All Health Issues"
						},
						...getAllProcedures.map(item => Object.assign({}, item))
						],
						languages: [{
							id: 'any',
							name: "All Languages"
						},
						...getAllLanguages.map(item => Object.assign({}, item))
						]
					}
					resolve(doctorListFilter);
				}).catch(error => {
					reject(error);
				});
		});
	}

	getDoctorOrConditionList(lang) {
		return new Promise((resolve, reject) => {
			this.apollo
				.query({
					query: gql `
					query {
						getAllProcedures(lang:"${lang}") {
							id
							name
						  }
						  getAllDoctors(lang:"${lang}") {
							id
							firstName
							lastName
							image
							title
							
							address{
							  city
							  state
							}							
						  }
						}
					`
				})
				.then(result => {
					const {
						getAllProcedures,
						getAllDoctors
					} = result.data;
					let doctors = [...getAllDoctors.map(item => {
						return {
							...item,
							name: `${item.firstName} ${item.lastName}`,
							city: item.address.city,
							state: item.address.state,
							"type": "doctor"
						}
					})];
					let procedure = getAllProcedures.map(item => {
						return {
							...item,
							"type": "condition_procedure"
						}
					})
					let response = [...doctors, ...procedure]
					resolve(response)
				}).catch(error => {
					reject(error)
				})

		})

	}

	filterByCarrier(carrierId) {
		return new Promise((resolve, reject) => {
			const doctorListFiltered = doctorList.filter(item => {
				const carriersFilter = item.carriers.find(element => element.id === carrierId);
				return (carriersFilter) ? item : null;
			});
			resolve(doctorListFiltered);
			reject({
				// error: ""
			});
		})
	}

	filter({
		selectedPlan,
		selectedAddress,
		selectedDoctor
	}) {

		const doctorid = (selectedDoctor && selectedDoctor.type === "doctor") ? selectedDoctor.id : 0;
		const carrierid = (selectedPlan) ? selectedPlan.carrierid : 0;
		const zipcode = (selectedAddress) ? selectedAddress.zip : 0;
		const procedureid = (selectedDoctor && selectedDoctor.type === "condition_procedure") ? selectedDoctor.id : 0;
		return new Promise((resolve, reject) => {
			this.apollo
				.query({
					query: gql `
					query {
						getFilteredDoctors(doctorid: ${doctorid}, carrierid: ${carrierid}, zipcode: ${zipcode}, procedureid: ${procedureid}) {
							id
							firstName
							lastName
							age
							title
							gender
							details
							address {
							  id
							  city
							  zip
							  latitude
							  longitude
							  state
							  streetAddress
							  country
							}
							horary {
							  id
							  date
							}
							image
							rating
						
							procedure {
							  id
							  name
							}
							language {
							  id
							  name
							}
						}
						}
					`
				})
				.then(result => {
					const {
						getFilteredDoctors
					} = result.data;


					let doctors = getFilteredDoctors.map(item => {
						return {
							doctor: {
								name: `${item.firstName} ${item.lastName} ${item.title}`,
								synthesis: (item.details) ? item.details : '',
								address: this.formatedAddress((item.address[0]) ? item.address[0] : {}),
								stars: (item.rating) ? item.rating : '',
								profession: '',
								image: (item.image) ? item.image : '',
								gender: item.gender,
							},
							isSponsored: false,
							horary: this.createHorary(item.horary),
							carriers: (item.carriers) ? [...item.carriers] : [],
							procedures: (item.procedure) ? [...item.procedure.map(item => Object.assign({}, item))] : [],
							languages: (item.language) ? [...item.language.map(item => Object.assign({}, item))] : [],
							address: (item.address) ? [...item.address.map(item => Object.assign({}, item))] : [],
						}
					})
					resolve(doctors);
				}).catch(error => {
					reject(error);
				});
		})
	}
}

appointmentFinderService.$inject = ['$http', 'apollo'];
export default appointmentFinderService;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/appointment-finder/appointment-finder-graphql.service.js